import React from "react";

const SignedInStatusIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#008B00" {...props}>
    <path d="M1.33331 14V2H7.99998V4.66667H14.6666V14H1.33331ZM2.66665 12.6667H3.99998V11.3333H2.66665V12.6667ZM2.66665 10H3.99998V8.66667H2.66665V10ZM2.66665 7.33333H3.99998V6H2.66665V7.33333ZM2.66665 4.66667H3.99998V3.33333H2.66665V4.66667ZM5.33331 12.6667H6.66665V11.3333H5.33331V12.6667ZM5.33331 10H6.66665V8.66667H5.33331V10ZM5.33331 7.33333H6.66665V6H5.33331V7.33333ZM5.33331 4.66667H6.66665V3.33333H5.33331V4.66667ZM7.99998 12.6667H13.3333V6H7.99998V7.33333H9.33331V8.66667H7.99998V10H9.33331V11.3333H7.99998V12.6667ZM10.6666 8.66667V7.33333H12V8.66667H10.6666ZM10.6666 11.3333V10H12V11.3333H10.6666Z" />
  </svg>
);

export default SignedInStatusIcon;
